export default __webpack_public_path__ + "static/Vendor_Code_Of_Conduct_short_version_2025-f9a1f58651a4482c7500e64453021a8a.pdf";